import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=07d5867e&scoped=true"
import script from "./trash.vue?vue&type=script&lang=js"
export * from "./trash.vue?vue&type=script&lang=js"
import style0 from "./trash.vue?vue&type=style&index=0&id=07d5867e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5867e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d5867e')) {
      api.createRecord('07d5867e', component.options)
    } else {
      api.reload('07d5867e', component.options)
    }
    module.hot.accept("./trash.vue?vue&type=template&id=07d5867e&scoped=true", function () {
      api.rerender('07d5867e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/trash.vue"
export default component.exports